/**
 * Created by laugh on 8/24/2017.
 */
import React, { Component } from 'react';
import $ from 'jquery';
import logo from '../assets/img/mealtrist-logo.png';
import { Link } from 'react-router-dom';
import * as ReactBootstrap from 'react-bootstrap';
import '../App.css';

class MainHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {redirecting: false, provider: "cox", leadSource: "500", tfn: "772-452-4565", text: "The TransactionID is "};
    }

    componentWillMount() {
        // if(this.state.provider != "") {
        //     require('../assets/css/' + this.state.provider + '.css');
        // }

    }

    //TODO set referrer url link in containers first child link
    render() {
        return (
            <div>
                <header>
                    <div className="container">
                        <div className="row">
                            <ReactBootstrap.Navbar fluid collapseOnSelect>
                                <ReactBootstrap.Navbar.Header>
                                    <ReactBootstrap.Navbar.Brand>
                                        <a><img className="img-responsive" height="60" width="60" src={logo} alt="mealtrist-logo" /></a>
                                    </ReactBootstrap.Navbar.Brand>
                                    <ReactBootstrap.Navbar.Toggle />
                                </ReactBootstrap.Navbar.Header>
                                <ReactBootstrap.Navbar.Collapse>
                                    <ReactBootstrap.Nav>
                                        <ReactBootstrap.NavItem eventKey={1} href="#">
                                            <span className="lead"> Mealtrist - Cook, Share, and Prepare</span>
                                        </ReactBootstrap.NavItem>
                                        <ReactBootstrap.NavItem eventKey={2} href="#">

                                        </ReactBootstrap.NavItem>
                                        <ReactBootstrap.NavItem eventKey={3} href="#">

                                        </ReactBootstrap.NavItem>
                                        <ReactBootstrap.NavItem eventKey={4} href="#">

                                        </ReactBootstrap.NavItem>
                                        <ReactBootstrap.NavItem eventKey={5} href="#">

                                        </ReactBootstrap.NavItem>
                                    </ReactBootstrap.Nav>
                                    <ReactBootstrap.Nav pullRight>
                                        <ReactBootstrap.NavItem eventKey={7} href="#">
                                            <Link to="login" >Login/Register</Link>
                                        </ReactBootstrap.NavItem>
                                        <ReactBootstrap.NavItem eventKey={8} href="#">

                                        </ReactBootstrap.NavItem>
                                    </ReactBootstrap.Nav>
                                </ReactBootstrap.Navbar.Collapse>
                            </ReactBootstrap.Navbar>
                        </div>
                    </div>
                </header>
            </div>
        );
    }
}

export default MainHeader;


// WEBPACK FOOTER //
// ./src/components/header.js